import remove from 'lodash/remove';
import api from '@/api';
import { UserTypes } from '@/constants';
import { subUsers } from '@/utils';

export default {
  namespaced: true,

  state: {
    profile: {},
    users: [],
  },

  getters: {
    systemUsers: (state) => {
      return state.users.filter(item => item.type === UserTypes.System);
    },
    adminUsers: (state) => {
      return state.users.filter(item => item.type === UserTypes.Admin);
    },
    normalUsers: (state) => {
      return state.users.filter(item => item.type === UserTypes.Normal);
    },
    subUsers: (state, _getters, rootState) => {
      const userId = rootState.auth.profile.id || 0;
      return subUsers(state.users, userId);
    },
  },

  actions: {
    async GetUsers({ commit }) {
      const { users } = await api.user.getUsers();
      commit('SET_USERS', users);
      return users;
    },
    async AddUser({ commit }, userForm) {
      const { user } = await api.user.addUser({ ...userForm });
      commit('ADD_USER', user);
      return user;
    },

    // 有权限的账号管理其他账号
    async UpdateUser({ commit, rootState }, userForm) {
      const { user } = await api.user.putUser({ ...userForm });
      commit('UPDATE_USER', user);

      // 更新本人信息
      if (user.id === rootState.auth.profile.id) {
        commit('SET_PROFILE', user, { root: true });
      }

      return user;
    },
    // 更新本账号信息
    async UpdateProfile({ commit }, userForm) {
      const { user } = await api.user.postUserProfile({ ...userForm });
      commit('UPDATE_USER', user);
      commit('SET_PROFILE', user, { root: true });

      return user;
    },
    async PatchUserDisable({ commit }, userForm) {
      const { user } = await api.user.patchUserDisable({ ...userForm });
      commit('UPDATE_USER', user);
      return user;
    },
    async DeleteUser({ commit }, user) {
      await api.user.deleteUser({ userId: user.id });
      commit('DELETE_USER', user);
    },
  },

  mutations: {
    SET_USERS(state, users) {
      state.users = users;
    },
    ADD_USER(state, user) {
      const { users } = state;
      state.users = [...users, user];
    },
    UPDATE_USER(state, user) {
      const { users } = state;
      const target = users.find(item => item.id === user.id);

      // 仅更新个人信息时users列表可能为空
      if (target) {
        Object.assign(target, user);
        state.users = [...users];
      }
    },
    DELETE_USER(state, user) {
      const { users } = state;
      remove(users, item => item.id === user.id);
      state.users = [...users];
    },
  },
};
